import { Node } from 'prosemirror-model'
import { Decoration } from 'prosemirror-view'
import { nodesDecorators } from './decorators'
import { TrackedChange } from 'prose-core'
import { isNodeName } from './utils'

export function createNodeDecorations(
  node: Node,
  pos: number,
  doc: Node,
  decorations: Decoration[],
  selectedUuid?: string,
) {
  if (!node.attrs.trackedChanges) return []

  node.attrs.trackedChanges.forEach(({ type, uuid }: TrackedChange) => {
    const $pos = doc.resolve(pos)
    const nodeName = isNodeName(node.type.name) ? node.type.name : undefined
    if (!nodeName) {
      throw new Error('Invalid node name')
    }
    const decorator = nodesDecorators[nodeName]
    const decoration = decorator(type, node, $pos, uuid, uuid === selectedUuid)
    if (!decoration) {
      return
    }
    if (Array.isArray(decoration)) {
      decoration.forEach((d) => decorations.push(d))
    } else {
      decorations.push(decoration)
    }
  })
}
